/* ------------------------------------------------------------------------------
@name: ContentTransition
@description: ContentTransition
--------------------------------------------------------------------------------- */

import WindowScroll from '@utilities/WindowScroll';
import WindowResize from '@utilities/WindowResize';

const ContentTransition = (() => {
  const $scaleHeight = $(window).width() < 992 ? 1.05 : 0.95;

  // - handlePositionCheck
  const handlePositionCheck = () => {
    $('.content-transition').each((idx, el) => {
      var $elementTop = $(el).offset().top;
      var $viewportTop = WindowScroll.top();
      var $viewportBottom = $viewportTop + $scaleHeight * $(window).height();

      if ($elementTop <= $viewportBottom) {
        $(el).addClass('visible');
      } else {
        // $(el).removeClass('visible');
      }
    });
  };

  // - handleScrollContentTransition
  const handleScrollContentTransition = () => {
    const contentList = [
      // experience
      '.experience__card__item',
      '.experience-detail__item',
      '.project__card__item--ttl',
      '.project__card__item__img'
    ];

    $.each(contentList, (idx, el) => {
      $(el).addClass('content-transition');
    });

    WindowScroll.run(handlePositionCheck);
  };

  // - handleShowBackToTop
  const handleShowBackToTop = () => {
    if (!$('.js-main-site').height() > $(window).height() * 2) return;

    const $viewportTop = WindowScroll.top();
    const $elementStart = $(window).height() * 1.5;
    let $elementChangeColor = $('.footer').offset().top;
    const $viewportBottom = $viewportTop + $(window).height();

    if ($elementStart <= $viewportBottom) {
      $('body').addClass('show--btt');
    } else {
      $('body').removeClass('show--btt');
    }
  };

  // - init
  const init = () => {
    if (!$('.main-site').length) return;
    handleScrollContentTransition();
    const HPCTO = setTimeout(() => {
      handlePositionCheck();
      clearTimeout(HPCTO);
    }, 50);
    WindowResize.resize(handlePositionCheck);
    WindowScroll.run(handleShowBackToTop);
  };

  return {
    init
  };
})();

export default ContentTransition;
